import { useIsMobile } from '@aries/shared/utils';
import axios from 'axios';
import useSWR from 'swr';

export const useIsUserInUS = () => {
  const isMobile = useIsMobile();

  const { data: isUserInUS = false, isValidating } = useSWR<boolean>(
    ['isUserInUS', isMobile],
    async () => {
      const response = await axios.get(
        isMobile
          ? `https://app.ariesmarkets.xyz/api/check-ip`
          : '/api/check-ip',
      );
      return response.data.isUsIp;
    },
    { revalidateOnFocus: false, revalidateIfStale: false },
  );

  return { isUserInUS, isCheckingUserIpLoading: isValidating };
};
